import styled from 'styled-components';
import globalStyles from './global-styles';
import spacer from './spacer';

export default styled.textarea`
  ${globalStyles}
  ${({ $noSpacer }) => !$noSpacer && spacer}
  min-height: 12rem;
`;
